// Actions
export const setActiveHistory = ({ commit }, payload) => {
  commit('SET_ACTIVE_HISTORY', payload)
}
export const addActiveHistory = ({ commit }, payload) => {
  commit('ADD_ACTIVE_HISTORY', payload)
}
export const addActiveHistoryRemoved = ({ commit }, payload) => {
  commit('ADD_ACTIVE_HISTORY_REMOVED', payload)
}
export const setActiveHistoryLoading = ({ commit }, payload) => {
  commit('SET_ACTIVE_HISTORY_LOADING', payload)
}

export const setAccounts = ({ commit }, payload) => {
  commit('SET_ACCOUNTS', payload)
}
export const addAccounts = ({ commit }, payload) => {
  commit('ADD_ACCOUNTS', payload)
}
export const setAccountsLoading = ({ commit }, payload) => {
  commit('SET_ACCOUNTS_LOADING', payload)
}

export const setActiveCurrent = ({ commit }, payload) => {
  commit('SET_ACTIVE_CURRENT', payload)
}
export const addActiveCurrent = ({ commit }, payload) => {
  commit('ADD_ACTIVE_CURRENT', payload)
}
export const setActiveCurrentLoading = ({ commit }, payload) => {
  commit('SET_ACTIVE_CURRENT_LOADING', payload)
}
export const setOperations = ({ commit }, payload) => {
  commit('SET_OPERATIONS', payload)
}
export const addOperations = ({ commit }, payload) => {
  commit('ADD_OPERATIONS', payload)
}
export const setOperationsLoading = ({ commit }, payload) => {
  commit('SET_OPERATIONS_LOADING', payload)
}

export const setOperationsBase = ({ commit }, payload) => {
  commit('SET_OPERATIONS_BASE', payload)
}
export const addOperationsBase = ({ commit }, payload) => {
  commit('ADD_OPERATIONS_BASE', payload)
}
export const setOperationsBaseLoading = ({ commit }, payload) => {
  commit('SET_OPERATIONS_BASE_LOADING', payload)
}

export const setCurrentStatus = ({ commit }, payload) => {
  commit('SET_CURRENT_STATUS', payload)
}
export const setComparisonInvestmentAccounts = ({ commit }, payload) => {
  commit('SET_COMPARISON_INVESTMENT_ACCOUNTS', payload)
}
export const addComparisonInvestmentAccounts = ({ commit }, payload) => {
  commit('ADD_COMPARISON_INVESTMENT_ACCOUNTS', payload)
}
export const setComparisonInvestmentAccountsLoading = ({ commit }, payload) => {
  commit('SET_COMPARISON_INVESTMENT_ACCOUNTS_LOADING', payload)
}

export const setSuggestions = ({ commit }, payload) => {
  commit('SET_SUGGESTIONS', payload)
}
export const setSuggestionsLoading = ({ commit }, payload) => {
  commit('SET_SUGGESTIONS_LOADING', payload)
}

export const setDataRoomLoading = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_LOADING', !!payload)
}

export const setDataRoomFilters = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_FILTERS', payload)
}
